module.exports = __webpack_public_path__ + "img/ES.c3853709.svg";